import React, { FC, useEffect, useState } from "react";
import { Row, Collapse } from "antd";
// import "./overview.scss";

import HealthStats from "../health-stats";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import { formatDisplayDate } from "@utils/helpers";
import CustomTooltip from "@pages/tool-tip";

const { Panel } = Collapse;

const CurrentHealthStats: FC<any> = (props) => {
  const [activePanel, setActivePannel] = useState<any[]>(["1"])

  useEffect(()=>{
    console.log("CurrentHealthStats.useEffect");
    setActivePannel([...props.activeKey])
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activePanel.length > 0){
      setActivePannel([])
    }
    else
      setActivePannel(["1"])
  }


  const genExtra = (id: any) =>
  <PinUnpin marginRight={"16px"} dataCardId={id}
  changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds} />;

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "7px 8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  return (
    <>
      <Collapse
        accordion
        activeKey={activePanel}
        expandIconPosition="right"
        bordered={false}
        onChange={onCollapseChange}
      >
        <Panel
          header={getHeading("Current Health Stats")}
          key="1"
          className="title"
          extra={genExtra(props?.data?.currentHealthStats?.datacardId)}
          style={{marginBottom:"8px"}}
        >
          <Row>
            {props?.data?.currentHealthStats?.values?.map((obj: any, index: number) => (
              <HealthStats
                size={8}
                name={obj.name}
                value={obj.value}
                date={formatDisplayDate(obj.refreshDate, "reminderDateActualFormat", "")}
                unit={obj.unit}
                status={obj.flag}
                key={`healthStats${index}`}
              />
            ))}
          </Row>
        </Panel>
      </Collapse>
    </>
  );
};

export default CurrentHealthStats;
